import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { TaskSendToGtNetResponseInterface } from '../definitions/task-send-to-gtnet.interface';

@Injectable()
export class TaskSendToGtNetService {

  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public taskSend(id: string): Observable<TaskSendToGtNetResponseInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${id}/send-to-gtnet`;

    return this.client.post<TaskSendToGtNetResponseInterface>(url, {}).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
